export default __webpack_public_path__ + "static/056-9b9c5168ec771bab574136ae73f5b9b1.jpg";